import { legacyRootReducer } from '../../legacy/redux/reducers';
import { combineReducers } from "redux";
import { usersReducer } from "./usersReducer";
import { accountsReducer } from "./accountsReducer";
import { assetsReducer } from "./assetsReducer";
import { streamsReducer } from "./streamsReducer";
import { hubReducer } from "./hubReducer";
import { streamAccessControllerReducer } from "./streamAccessControllerReducer";
import { customFieldsReducer } from "./customFieldsReducer";
import { collectionsReducer } from './collectionsReducer';
import { dataSourceReducer } from "./dataSourceReducer";
import { entitiesReducer } from "./entitiesReducer";
import { groupsReducer } from "./groupsReducer";
import { searchReducer } from "./searchReducer";
import contentMapReducer from './contentMapReducer';
import { mediaLibraryReducer } from "./mediaLibraryReducer";
import { mediaReducer } from "./mediaReducer";
import { microsoftWopiIntegrationReducer } from './microsoftWopiIntegrationReducer';
import { gDocIntegrationReducer } from './gDocIntegrationReducer';
import { linkReducer } from './linkReducer';
import { notificationReducer } from './notificationReducer';
import { seekReducer } from './seekReducer';
import { dealRoomsReducer } from './dealRoomsReducer';
import { conversationsReducer } from './conversationReducer';
import { backgroundTasksReducer } from './backgroundReducer';
import { cleverstoryReducer } from './cleverStoryReducer';
import AuthService from 'src/utils/auth.service';
import { LOGOUT_USER } from '../actions/actionTypes';
import { coursesReducer } from './coaching/coursesReducer';
import { contactReducer } from './contactReducer';
import { oraganizationReducer } from './organizationReducer';
import { OpportunityReducer } from './opportunityReducer';
import { linkedInReducer } from './integrations/linkedInReducer';
import { emailTemplatesReducer } from './emailTemplatesReducer';
import { ndaReducer } from './ndaTemplateReducer';
import shareTemplateReducer from './shareTemplateReducer';
import { learnersReducer } from './coaching/learnersReducer';
import { scenariosReducer } from './simulation/scenariosReducer';
import { reportsReduder } from './coaching/reportsReducer';
import { simulationReducer } from './coaching/simulationReducer';
import { ReferralReducer } from './referralReducer';
import { settingsReducer } from './coaching/settingsReducer';
import { exploreReducer } from './coaching/exploreReducer';
import { podcastsReducer } from './coaching/podcastsReducer';
import { studioReducer } from './coaching/studioReducer';
import { reportsReducer } from './reportsReducer';
import { callRecordingReducer } from './coaching/callRecording';
import {microLearningReducer} from './coaching/microLearningReducer'
import { hubspotReducer } from './integrations/hubspotReducer';
import { callMeetingReducer } from './coaching/callLibraryReducer';
import { gamificationReducer } from './coaching/gamificationReducer';

const appReducer = combineReducers({
  legacyRootReducer: legacyRootReducer,
  accounts: accountsReducer,
  users: usersReducer,
  asset: assetsReducer,
  stream: streamsReducer,
  hub: hubReducer,
  streamAccessControl: streamAccessControllerReducer,
  customFields: customFieldsReducer,
  collections: collectionsReducer,
  dataSource: dataSourceReducer,
  entities: entitiesReducer,
  group: groupsReducer,
  search: searchReducer,
  contentMap: contentMapReducer,
  mediaLibrary: mediaLibraryReducer,
  media: mediaReducer,
  link: linkReducer,
  microsoftWopiIntegration: microsoftWopiIntegrationReducer,
  gDocIntegration: gDocIntegrationReducer,
  notification: notificationReducer,
  conversations: conversationsReducer,
  backgroundTasks: backgroundTasksReducer,
  seek: seekReducer,
  dealRooms: dealRoomsReducer,
  cleverStory : cleverstoryReducer,
  contact:contactReducer,
  organizations: oraganizationReducer,
  opportunities: OpportunityReducer,
  integrations: combineReducers({
    linkedIn: linkedInReducer,
    hubspot: hubspotReducer
  }),
  emailTemplate: emailTemplatesReducer,
  nda: ndaReducer,
  shareTemplates: shareTemplateReducer,
  scenarios: scenariosReducer,
  courses: coursesReducer,
  learners: learnersReducer,
  coaching: combineReducers({
    settings: settingsReducer,
    explore: exploreReducer,
    studio: studioReducer,
    simulations: simulationReducer,
    reports: reportsReduder,
    podcasts: podcastsReducer,
    callRecordings: callRecordingReducer,
    microLearnings: microLearningReducer,
    callMeetings: callMeetingReducer,
    gamification: gamificationReducer,
  }),
  referralInfo: ReferralReducer,
  reports: reportsReducer,
});

export const rootReducer = (state, action) => {
  if (action.type == LOGOUT_USER) {
    state = undefined;
    AuthService.clearAccessToken();
  }

  return appReducer(state, action);
};